import httpClient, { ConexaResponse } from '@/services/httpClient'
import type {
  INPS,
  INPSRequest,
  SaveNewNPSResponse,
  SaveResolvabilityParams,
} from './types'
import { SaveNpsMapper } from './mappers/SaveNPSMapper/SaveNPSMapper'
import {
  SaveNPSData,
  SaveNPSToDomain,
} from './mappers/SaveNPSMapper/SaveNPSMapper.types'
import { PlatformRatingFormValues } from './pages/PlatformRating/PlatformRating.types'
import { SaveNPSPlatformMapper } from './mappers/SaveNPSPlatformMapper/SaveNPSPlatformMapper'

export const saveNPS = async (
  consultationId: string,
  nps: INPS,
): Promise<boolean> => {
  const requestBody: INPSRequest = {
    idAtendimento: Number(consultationId),
    avaliaProfissional: nps.professionalEvaluation,
    ...(nps.professionalEvaluation && {
      medico: {
        avaliacao: nps.professional.rating,
        comentario: nps.professional.comment || '',
        detalhes: nps.professional.details || [],
        nps: nps.professional.nps,
      },
      plataforma: {
        avaliacao: nps.platform.rating,
        comentario: nps.platform.comment || '',
        detalhes: nps.platform.details || [],
        nps: nps.platform.nps,
      },
    }),
    ...(!nps.professionalEvaluation && {
      atendimentoSemChamada: {
        comentario: nps.appointmentWithoutCall.comment,
        motivo: nps.appointmentWithoutCall.reason,
      },
      plataforma: {
        avaliacao: nps.platform.rating,
        comentario: nps.platform.comment || '',
        detalhes: nps.platform.details || [],
        nps: nps.platform.nps,
      },
    }),
  }

  const response = await httpClient.post(
    '/integration/app-paciente/avaliacao-atendimento/salvar',
    requestBody,
  )

  return response?.data?.object || false
}

export const unansweredNps = async (): Promise<void> => {
  await httpClient.get('/integration/app-paciente/nps/naorespondido')
}

export const saveResolvability = async (
  params: SaveResolvabilityParams,
): Promise<void> => {
  const { consultationId, consultationReason, wasResolutive } = params

  await httpClient.post(
    '/integration/app-paciente/atendimento/salvar-satisfacao-paciente',
    {
      idAtendimento: consultationId,
      motivoConsulta: consultationReason,
      atendimentoResolutivo: wasResolutive,
    },
  )
}

export const saveNewNPS = async (
  params: SaveNPSData,
): Promise<SaveNPSToDomain> => {
  const response = await httpClient.post<ConexaResponse<SaveNewNPSResponse>>(
    '/integration/app-paciente/avaliacao-atendimento/salvar/v2',
    SaveNpsMapper.toPersistence(params),
  )

  return SaveNpsMapper.toDomain(response.data.object)
}

export const patientCanAnswerNPSPlatform = async (): Promise<boolean> => {
  const response = await httpClient.get<ConexaResponse<boolean>>(
    '/integration/app-paciente/avaliacao-plataforma/deve-responder',
  )

  return response?.data?.object
}

export const saveNPSPlatform = async (data: PlatformRatingFormValues) => {
  await httpClient.post(
    '/integration/app-paciente/avaliacao-plataforma/salvar',
    SaveNPSPlatformMapper.toPersistence(data),
  )
}
